<template>
    <div>
        <div class="table-blog">
        <div
          style="position: absolute;top: 45%; left: 50%; width: 10%; z-index: 2;"
          v-show="loading == true"
        >
          <md-progress-spinner :md-stroke="8" :md-diameter="65" md-mode="indeterminate"></md-progress-spinner>
        </div>
        <div class="head-table">
          <div class="col" style="width :40%">Campaign Name</div>
          <div class="col" style="width :20%;text-align:right">Campaign cost</div>
          <div class="col" style="width :15%;text-align:right">Gross profit</div>
          <div class="col" style="width :15%;text-align:right">Reward cost</div>
          <div class="col" style="width :10%;text-align:right">Net profit</div>
        </div>
        <div class="body-table">
          <div
            class="row-table"
            v-for="(item , index) in searched"
            :key="'row-table-'+index"
          >
            <div
              class="col top-line"
              style="width :40%;font-family:kanit;word-wrap: break-word;"
            >{{ item.campaign_title }}</div>
            <div
              class="col top-line"
              style="width :20%;text-align:right"
            >{{ item.campaign_cost.toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                    }) }}</div>
            <div
              class="col top-line"
              style="width :15%;text-align:right"
            >{{ item.gross_profit.toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                    }) }}</div>
            <div
              class="col top-line"
              style="width :15%;text-align:right"
            >{{item.reward_cost.toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                    })}}</div>
            <div
            class="col top-line"
              style="width :10%;text-align:right"
              v-bind:class="{ minus: checkMinus(item.profit,item.reward_cost) }">
                {{calProfit(item.gross_profit,item.reward_cost)}}
            </div>
          </div>
        </div>
      </div>
      
          <campaignInfo :dataCampaign="campaign" v-if="showDetail" @close="showDetail = false"></campaignInfo>

    </div>
</template>

<script>
import CampaignService from "@/services/campaign";
import campaignInfo from "@/components/campaign/track/infomation";

import moment from "moment-timezone";

export default {
    name: "track-campaign",
    components:{
            campaignInfo,
    },
    props: ["keyword"],
    data(){
        return {
            showDetail: false,
            loading: false,
            search: null,
            searched: [],
            campaign: {}
        }   
  },
  watch:{
    keyword(val){
      //console.log(val);
      this.search = val;
      this.searchOnTable();
    }
  },
  methods: {
    searchOnTable() {
      const response = this.searchedTemp.filter(word => {
        const str = word.campaign_title;
        // const str = word.code + word.first_name+ word.last_name+ word.last_name;
        return str.toUpperCase().indexOf(this.search.toUpperCase()) !== -1;
      });
      this.searched = response;

    },
    formatNum(value) {
      if (value != "" && value != null) {
        return "";
      } else {
        return parseFloat(value)
          .toFixed(0)
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
    },

    genDateView(startdate, enddate) {
      //March 1, 2018 to April 31, 2018
      const date = moment(new Date(startdate));
      const date2 = moment(new Date(enddate));
      return `${date.format("MMM D, YYYY")} to ${date2.format("MMM D, YYYY")}`;
    },
    showDetailPanel(item) {
      CampaignService.getReportInfo(item._id).then(response => {
        // console.log(response)
        if (response.customers.length > 0) {
          if (response.customers[0] == null) {
            response.customers = [];
          }
        }
        this.campaign = response;
        this.showDetail = true;
      });
    },
    calPercent(val){
      let data = Math.floor(((val.countRedeem * 100) / val.numJoined));
      if(isNaN(data)) return 0 + " %";
      else return data+" %";
    },
    calProfit(profit,reward)
    {
      return (profit - reward).toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                    });
    },
    checkMinus(profit,reward)
    {
      if(profit - reward < 0) return true;
      else return false;
    }
  },
  created() {
    this.loading = true;
    CampaignService.getReportCompareCost().then(res => {
      this.campaign = res;
      this.searched = this.campaign;
      this.searchedTemp = _.cloneDeep(this.campaign);
      this.loading = false;
    });
  }
}
</script>

<style lang="scss" scoped>
.table-blog {
      width: 100%;
      padding-left: 5px;
      padding-right: 5px;
      // padding: 0px 30px 30px 30px;
      .col {
        padding-right: 10px;
        // padding-left:20px;
      }
      .head-table {
        margin-bottom: 20px;
        display: -webkit-box;
        font-size: 13px;
        font-family: lato;
        font-weight: bold;
        padding-left: 25px;
        padding-right: 25px;
      }
      .body-table {
        height: calc(100vh - 205px);
        overflow-y: scroll;
        overflow-x: hidden;
        .row-table {
          padding-left: 25px;
          padding-right: 20px;
          display: -webkit-box;
          font-family: lato;
          font-size: 13px;
          margin-bottom: 5px;
          .top-line {
            padding-top: 7px;
            padding-bottom: 7px;
          }
        }
        .row-table:hover {
          background: rgba(236, 236, 235, 1);
          // cursor: pointer;
          border-radius: 3px;
        }
      }
      .body-table::-webkit-scrollbar {
        height: 7px;
        width: 5px;
      }
    }
    .footer-table {
      display: block;
      text-align: center;
      margin-top: 5px;
      padding-bottom: 15px;
      width: 99.6%;
      font-size: 14px;
      font-style: italic;
    }
    .minus{
      color:red !important;
    }
</style>

